import React from 'react'
import {IIncomeDocument} from '../IncomeDocumentDetailPage'
import {Col, Row} from 'react-bootstrap'
import {KTCard, KTCardBody} from '../../../../_metronic/helpers'
import {numberFormat} from '../../../utils/Functions'
import {IncomeDocumentTypes} from '../../../constants/Common'
import {Link} from 'react-router-dom'
import {getRevenuePrefixPath} from '../../../utils/Helper'
import {formatDate} from '@fullcalendar/core'
import {
  DEBT_ADDITION_REASONS,
  DEBT_REDUCTION_REASONS,
  PRODUCT_RECEIVE_OPTIONS,
  PRODUCT_RETURN_OPTIONS,
} from '../../../utils/common'

interface ITabDocumentExpensePurchaseNote {
  data: IIncomeDocument
  type: IncomeDocumentTypes
}

const TabDocumentExpensePurchaseNote: React.FC<ITabDocumentExpensePurchaseNote> = (props) => {
  const {data, type} = props

  const document = data

  const totalDepositAmount = document.totalAmount
  const incomeDocumentPaymentDeductions = document?.incomeDocumentPaymentDeductions?.filter(
    (item) => !item?.isCombined && !item?.isUseForPaid
  )

  const totalDeducted = incomeDocumentPaymentDeductions?.reduce((a, b) => a + b.amount, 0) || 0
  const currentTotal =
    type === IncomeDocumentTypes.EXPENSE_PURCHASE_DEBIT_NOTE
      ? totalDepositAmount + totalDeducted
      : totalDepositAmount - totalDeducted

  const textType =
    type === IncomeDocumentTypes.EXPENSE_PURCHASE_CREDIT_NOTE ? 'ใบลดหนี้' : 'ใบเพิ่มหนี้'

  return (
    <div>
      <KTCard>
        <KTCardBody className={'py-3 px-4'}>
          <Row className={'fs-6'}>
            <Col xs={12}>
              <h4>{`ข้อมูลรับ${textType}`}</h4>
            </Col>
            <Col md={6} className={'border-end'}>
              <div className={'d-flex justify-content-between'}>
                <strong>{`มูลค่าเต็ม${
                  document.type === IncomeDocumentTypes.EXPENSE_EXPENSE_RECORD
                    ? 'บันทึกค่าใช้จ่าย'
                    : 'บันทึกซื้อสินค้า'
                } :`}</strong>
                <span>{`${numberFormat(totalDepositAmount)} บาท`}</span>
              </div>
              <div className={'d-flex justify-content-between'}>
                <strong>{`มูลค่า${textType}จำนวน ${incomeDocumentPaymentDeductions?.length} รายการ :`}</strong>
                <span>{`${numberFormat(totalDeducted)} บาท`}</span>
              </div>
              <div className={'d-flex justify-content-between'}>
                <strong>{`มูลค่าที่ถูกต้องของ${
                  document.type === IncomeDocumentTypes.EXPENSE_EXPENSE_RECORD
                    ? 'บันทึกค่าใช้จ่าย'
                    : 'บันทึกซื้อสินค้า'
                } :`}</strong>
                <span>{`${numberFormat(currentTotal)} บาท`}</span>
              </div>
            </Col>
          </Row>
        </KTCardBody>
      </KTCard>

      {/* แสดงข้อมูล linkingDocument + Deductions (ถ้ามี) ในการ์ดเดียว */}
      {document?.linkingDocument && (
        <KTCard className={'mt-3'}>
          <KTCardBody className={'py-3 px-4'}>
            <Row className={'fs-6'}>
              <Col xs={12}>
                <h4 style={{color: '#43bf76'}}>{`ข้อมูลเอกสารอ้างอิง`}</h4>
              </Col>
              <Col md={6} className={'border-end'}>
                <div className={'d-flex justify-content-between align-items-center gap-2'}>
                  <div className={'d-flex gap-2'}>
                    <strong>{'เลขที่เอกสาร :'}</strong>
                    <Link
                      to={`${getRevenuePrefixPath(document.linkingDocument.type)}/${
                        document.linkingDocument.id
                      }/detail`}
                    >
                      {document.linkingDocument.code}
                    </Link>
                  </div>
                  <div className={'d-flex gap-2'}>
                    <strong>{'วันที่ออกเอกสาร :'}</strong>
                    <span>{formatDate(document.linkingDocument.createdAt)}</span>
                  </div>
                </div>
                <div className={'d-flex justify-content-between'}>
                  <strong>{`มูลค่า${textType} :`}</strong>
                  <span>{`${numberFormat(document.linkingDocument.totalAmount)} บาท`}</span>
                </div>
              </Col>

              {!!document.linkingDocument?.debtReason && (
                <Col md={6}>
                  <div className='card px-3 mt-4 mt-md-0'>
                    <div className='card-body p-0'>
                      <div className='row mb-1'>
                        <div className='col-12 col-sm-3 col-md-5 fw-bold p-0 pe-3'>
                          {document.linkingDocument?.type ===
                          IncomeDocumentTypes.EXPENSE_PURCHASE_CREDIT_NOTE
                            ? 'สาเหตุของการลดหนี้'
                            : 'สาเหตุการเพิ่มหนี้'}
                        </div>
                        <div className='col-12 col-sm-9 col-md-7 p-0 ps-3'>
                          <span className='text-muted'>
                            {(() => {
                              const debt = (
                                document.linkingDocument?.type ===
                                IncomeDocumentTypes.EXPENSE_PURCHASE_CREDIT_NOTE
                                  ? DEBT_REDUCTION_REASONS
                                  : DEBT_ADDITION_REASONS
                              ) as {value: string; label: string}[]
                              const found = debt.find(
                                (item) => item.value === document.linkingDocument?.debtReason
                              )
                              return found
                                ? found.label
                                : document.linkingDocument?.debtReason || '-'
                            })()}
                          </span>
                        </div>
                      </div>
                      <div className='row mb-1'>
                        <div className='col-12 col-sm-3 col-md-5 fw-bold p-0 pe-3'>
                          คำอธิบายอย่างย่อ
                        </div>
                        <div className='col-12 col-sm-9 col-md-7 p-0 ps-3'>
                          <span className='text-muted'>
                            {document.linkingDocument?.shortDescription || '-'}
                          </span>
                        </div>
                      </div>
                      <div className='row mb-1'>
                        <div className='col-12 col-sm-3 col-md-5 fw-bold p-0 pe-3'>
                          {document.linkingDocument?.type ===
                          IncomeDocumentTypes.EXPENSE_PURCHASE_CREDIT_NOTE
                            ? 'มีการคืนสินค้าเพิ่มหรือไม่'
                            : 'มีการรับสินค้าเพิ่มหรือไม่'}
                        </div>
                        <div className='col-12 col-sm-9 col-md-7 p-0 ps-3'>
                          <span className='text-muted'>
                            {(() => {
                              const options = (
                                document.linkingDocument?.type ===
                                IncomeDocumentTypes.EXPENSE_PURCHASE_CREDIT_NOTE
                                  ? PRODUCT_RETURN_OPTIONS
                                  : PRODUCT_RECEIVE_OPTIONS
                              ) as {value: string; label: string}[]
                              const found = options.find((item) =>
                                document.linkingDocument?.type ===
                                IncomeDocumentTypes.EXPENSE_PURCHASE_CREDIT_NOTE
                                  ? item.value === document.linkingDocument?.hasProductReturn
                                  : item.value === document.linkingDocument?.hasProductReceive
                              )
                              return found
                                ? found.label
                                : (document.linkingDocument?.type ===
                                  IncomeDocumentTypes.EXPENSE_PURCHASE_CREDIT_NOTE
                                    ? document.linkingDocument?.hasProductReturn
                                    : document.linkingDocument?.hasProductReceive) || '-'
                            })()}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              )}
            </Row>
            {/* รายการ deductions ที่ currentDocId === linkingDocument.id */}
            {incomeDocumentPaymentDeductions
              ?.filter((item) => item.currentDocId === document.linkingDocument.id)
              .map((item, index) => {
                const incomeDocument = item
                const currentDoc = incomeDocument?.linkedDoc
                const pathPrefix = getRevenuePrefixPath(currentDoc?.type)
                return (
                  <div
                    className={'mt-3'}
                    key={'linkingDeduct-' + index}
                    style={{borderLeft: '2px solid #e1e1e1', padding: 12}}
                  >
                    <Row className={'fs-6'}>
                      <Col xs={12}>
                        <h5 style={{color: '#43bf76'}}>{`จ่ายชำระครั้งที่ ${index + 1}`}</h5>
                      </Col>
                      <Col md={6} className={'border-end'}>
                        <div className={'d-flex justify-content-between align-items-center gap-2'}>
                          <div className={'d-flex gap-2'}>
                            <strong>{'เลขที่เอกสาร :'}</strong>
                            <Link to={`${pathPrefix}/${currentDoc.id}/detail`} target='_blank'>
                              {currentDoc.code}
                            </Link>
                          </div>
                          <div className={'d-flex gap-2'}>
                            <strong>{'จ่ายชำระเมื่อวันที่ :'}</strong>
                            <span>{formatDate(incomeDocument.createdAt)}</span>
                          </div>
                        </div>
                        <div className={'d-flex justify-content-between'}>
                          <strong>{`มูลค่าที่ชำระ:`}</strong>
                          <span>{`${numberFormat(incomeDocument.amount)} บาท`}</span>
                        </div>
                      </Col>
                    </Row>
                  </div>
                )
              })}
          </KTCardBody>
        </KTCard>
      )}

      {/* incomeDocumentPaymentDeductions อื่นๆ ที่ไม่เกี่ยวกับ linkingDocument (ถ้ามี) */}
      {/* {incomeDocumentPaymentDeductions
        ?.filter(
          (item) => !document?.linkingDocument || item.currentDocId !== document.linkingDocument.id
        )
        .map((item, index) => {
          const incomeDocument = item
          const currentDoc = incomeDocument?.currentDoc
          const pathPrefix = getRevenuePrefixPath(incomeDocument.type)
          return (
            <KTCard className={'mt-3'} key={'deduct-' + index}>
              <KTCardBody className={'py-3 px-4'}>
                <Row className={'fs-6'}>
                  <Col xs={12}>
                    <h4 style={{color: '#43bf76'}}>{`เอกสารที่นำ${textType}ไปตัด ใบที่ ${
                      index + 1
                    }`}</h4>
                  </Col>
                  <Col md={6} className={'border-end'}>
                    <div className={'d-flex justify-content-between align-items-center gap-2'}>
                      <div className={'d-flex gap-2'}>
                        <strong>{'เลขที่เอกสาร :'}</strong>
                        <Link to={`${pathPrefix}/${incomeDocument.currentDocId}/detail`}>
                          {incomeDocument.code}
                        </Link>
                      </div>
                      <div className={'d-flex gap-2'}>
                        <strong>{'วันที่ออกเอกสาร :'}</strong>
                        <span>{formatDate(incomeDocument.createdAt)}</span>
                      </div>
                    </div>
                    <div className={'d-flex justify-content-between'}>
                      <strong>{`มูลค่า${textType} :`}</strong>
                      <span>{`${numberFormat(incomeDocument.amount)} บาท`}</span>
                    </div>
                  </Col>
                  {!!currentDoc?.debtReason && (
                    <Col md={6}>
                      <div className='card px-3 mt-4 mt-md-0'>
                        <div className='card-body p-0'>
                          <div className='row mb-1'>
                            <div className='col-12 col-sm-3 col-md-5 fw-bold p-0 pe-3'>
                              {currentDoc?.type === IncomeDocumentTypes.EXPENSE_PURCHASE_CREDIT_NOTE
                                ? 'สาเหตุของการลดหนี้'
                                : 'สาเหตุการเพิ่มหนี้'}
                            </div>
                            <div className='col-12 col-sm-9 col-md-7 p-0 ps-3'>
                              <span className='text-muted'>
                                {(() => {
                                  const debt = (
                                    currentDoc?.type ===
                                    IncomeDocumentTypes.EXPENSE_PURCHASE_CREDIT_NOTE
                                      ? DEBT_REDUCTION_REASONS
                                      : DEBT_ADDITION_REASONS
                                  ) as {value: string; label: string}[]
                                  const found = debt.find(
                                    (item) => item.value === currentDoc?.debtReason
                                  )
                                  return found ? found.label : currentDoc?.debtReason || '-'
                                })()}
                              </span>
                            </div>
                          </div>
                          <div className='row mb-1'>
                            <div className='col-12 col-sm-3 col-md-5 fw-bold p-0 pe-3'>
                              คำอธิบายอย่างย่อ
                            </div>
                            <div className='col-12 col-sm-9 col-md-7 p-0 ps-3'>
                              <span className='text-muted'>
                                {currentDoc?.shortDescription || '-'}
                              </span>
                            </div>
                          </div>
                          <div className='row mb-1'>
                            <div className='col-12 col-sm-3 col-md-5 fw-bold p-0 pe-3'>
                              {currentDoc?.type === IncomeDocumentTypes.EXPENSE_PURCHASE_CREDIT_NOTE
                                ? 'มีการคืนสินค้าเพิ่มหรือไม่'
                                : 'มีการรับสินค้าเพิ่มหรือไม่'}
                            </div>
                            <div className='col-12 col-sm-9 col-md-7 p-0 ps-3'>
                              <span className='text-muted'>
                                {(() => {
                                  const options = (
                                    currentDoc?.type ===
                                    IncomeDocumentTypes.EXPENSE_PURCHASE_CREDIT_NOTE
                                      ? PRODUCT_RETURN_OPTIONS
                                      : PRODUCT_RECEIVE_OPTIONS
                                  ) as {value: string; label: string}[]
                                  const found = options.find((item) =>
                                    currentDoc?.type ===
                                    IncomeDocumentTypes.EXPENSE_PURCHASE_CREDIT_NOTE
                                      ? item.value === currentDoc?.hasProductReturn
                                      : item.value === currentDoc?.hasProductReceive
                                  )
                                  return found
                                    ? found.label
                                    : (currentDoc?.type ===
                                      IncomeDocumentTypes.EXPENSE_PURCHASE_CREDIT_NOTE
                                        ? currentDoc?.hasProductReturn
                                        : currentDoc?.hasProductReceive) || '-'
                                })()}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>
                  )}
                </Row>
              </KTCardBody>
            </KTCard>
          )
        })} */}
    </div>
  )
}

export default TabDocumentExpensePurchaseNote
